import './style.scss';
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import Button from '../../../../../components/Button';
import { WebsiteConstants } from '../../../../../data/Constants';


interface IRequestQuoteProps {
    variant?: 'default' | 'tickets' | 'reservation';
}


const RequestQuote: React.FC<IRequestQuoteProps> = ({
    variant = 'default'
}) => {
    const { translate } = useLanguageContext();

    return <Box className='grid-content-section' id='requestquote' sx={{ backgroundImage: `url(${WebsiteConstants.requestQuote[`wallpaper_${variant}`]})` }}>
        <Typography variant='subtitle1' className='requestquote-title'>
            {translate(`requestQuoteTitle_${variant}`)}
            
            <Typography variant='body1' className='requestquote-description'>
                {translate(`requestQuoteDescription_${variant}`)}
            </Typography>
        </Typography>

        <Button 
            type='button'
            label={translate(`requestQuote_${variant}`)}
            className='requestquote-button'
            onClick={() => window.open(WebsiteConstants.requestQuote[`link_${variant}`])}
        />
    </Box>;
}

export default RequestQuote;